/** Parse S3 version folder names produced by {@link buildGatewayConfigVersion} (and legacy compact forms). */
export function parseGatewayConfigVersion(version) {
    const isoLike = /^(\d{4})-(\d{2})-(\d{2})T(\d{2})-(\d{2})-(\d{2})(?:-(\d{3}))?Z$/;
    const isoMatch = version.match(isoLike);
    if (isoMatch) {
        const [, year, month, day, hour, minute, second, millis] = isoMatch;
        const utc = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second), millis ? Number(millis) : 0));
        return Number.isNaN(utc.getTime()) ? null : utc;
    }
    if (version.length >= 12 && /^\d{12}/.test(version)) {
        const year = parseInt(version.slice(0, 4), 10);
        const month = parseInt(version.slice(4, 6), 10) - 1;
        const day = parseInt(version.slice(6, 8), 10);
        const hour = parseInt(version.slice(8, 10), 10);
        const minute = parseInt(version.slice(10, 12), 10);
        const utc = new Date(Date.UTC(year, month, day, hour, minute));
        return Number.isNaN(utc.getTime()) ? null : utc;
    }
    const parsed = Date.parse(version);
    if (!Number.isNaN(parsed))
        return new Date(parsed);
    return null;
}
/** Human-readable UTC timestamp for gateway config version strings. */
export function formatGatewayConfigVersion(version) {
    if (!version)
        return '—';
    const utcDate = parseGatewayConfigVersion(version);
    if (!utcDate)
        return version;
    const pad = (n) => String(n).padStart(2, '0');
    return `${utcDate.getUTCFullYear()}-${pad(utcDate.getUTCMonth() + 1)}-${pad(utcDate.getUTCDate())} ${pad(utcDate.getUTCHours())}:${pad(utcDate.getUTCMinutes())}`;
}
/** Push statuses where Resend MQTT is offered for the latest push row. */
export const GATEWAY_CONFIG_RESEND_ELIGIBLE_STATUSES = [
    's3_uploaded_mqtt_failed',
    'apply_timeout',
    'mqtt_sent',
];
export function gatewayConfigResendEligibleVersion(items) {
    const latest = items[0];
    if (!latest)
        return null;
    return GATEWAY_CONFIG_RESEND_ELIGIBLE_STATUSES.includes(latest.status)
        ? latest.configVersion
        : null;
}
//# sourceMappingURL=gateway-config-version.js.map